import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { AmountInput } from '@root/shared/ui-kit'

import type { IconProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  label: string
  icon?: React.FC<IconProps>
  endContent?: React.ReactNode
  valueFrom?: string
  valueTo?: string
  onChangeFrom: (value: string) => void
  onChangeTo?: (value: string) => void
} & ClassNameProps

export const ExploreFilterInputGroup: React.FC<Props> = ({
  label,
  endContent,
  valueFrom,
  valueTo,
  onChangeFrom,
  onChangeTo,
  icon,
}) => {
  const { t } = useTranslation()

  const handleChangeFrom = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeFrom(event.target.value)
  }

  const handleChangeTo = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeTo?.(event.target.value)
  }
  const Icon = icon

  return (
    <Root>
      <Label>
        {Icon ? <Icon size={18} color="var(--text-11)" /> : undefined}
        <span>{label}</span>
      </Label>
      <Group>
        <AmountInput
          placeholder={t('common.min')}
          endContent={endContent}
          value={valueFrom}
          onChange={handleChangeFrom}
        />
        {onChangeTo ? (
          <AmountInput
            placeholder={t('common.max')}
            endContent={endContent}
            value={valueTo}
            onChange={handleChangeTo}
          />
        ) : undefined}
      </Group>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4px;

  align-content: center;
  justify-content: center;
  align-items: center;
`

const Group = styled.div`
  display: grid;
  gap: 4px;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
`

const Label = styled.label`
  color: var(--text-11);

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 4px;
`
